var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_8817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1522 10.7323L24.2589 0.146484H22.1009L14.1936 9.33798L7.87801 0.146484H0.59375L10.1441 14.0457L0.59375 25.1465H2.75187L11.1022 15.44L17.7719 25.1465H25.0562L15.1517 10.7323H15.1522ZM12.1964 14.1681L11.2287 12.7841L3.52947 1.77108H6.84421L13.0576 10.6589L14.0253 12.043L22.1019 23.5958H18.7872L12.1964 14.1686V14.1681Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_8817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.324951 0.146484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.3752285b6a86e52a79950509e1968616.svg";
export { ForwardRef as ReactComponent };